export default __webpack_public_path__ + "static/media/agentes-de-ia-banner.f5c0c86f.png";